import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordPhoneFormCmsKey =
    | 'pleaseTryAgain'
    | 'pleaseEnterValidMobileNumber'
    | 'invalidOtpCode'
    | 'featureNotEnabled';

export const ForgotPasswordPhoneFormCmsWithDefault: CmsObjectWithDefault<ForgotPasswordPhoneFormCmsKey> = {
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    pleaseEnterValidMobileNumber: {
        cmsId: 85560,
        defaultTranslation: 'Please enter a valid mobile number.',
    },
    invalidOtpCode: {
        cmsId: 97933,
        defaultTranslation: 'The OTP code is incorrect. Please re-enter or request a new OTP.',
    },
    featureNotEnabled: {
        cmsId: 534026,
        defaultTranslation: 'Please use the associated email to reset the password on sign in page.',
    },
};
